
  function gtag_report_conversion(url) {
    // Retrieve the price from the span
    var priceElement = document.querySelector("span.add-to-cart--regular-price");
    var price = priceElement ? parseFloat(priceElement.innerText.replace(/[^0-9.]/g, '')) : 1.0; // Default to 1.0 if not found

    var callback = function () {
      if (typeof(url) != 'undefined') {
        window.location = url;
      }
    };
    
    gtag('event', 'conversion', {
      'send_to': 'AW-16751617597/-my7CMei8-AZEL3M5bM-',
      'value': price,
      'currency': 'USD',
      'event_callback': callback
    });
    
    return false;
  }

  // Attach the function to the ATC button
  document.addEventListener("DOMContentLoaded", function() {
    var atcButton = document.querySelector("button.add-to-cart--submit");
    if (atcButton) {
      atcButton.addEventListener("click", function(event) {
        gtag_report_conversion();
        console.log("ATC GAds recorded");
      });
    }
  });
